import { render, staticRenderFns } from "./PinnedNotes.vue?vue&type=template&id=2770e5e0"
import script from "./PinnedNotes.vue?vue&type=script&lang=js"
export * from "./PinnedNotes.vue?vue&type=script&lang=js"
import style0 from "./PinnedNotes.vue?vue&type=style&index=0&id=2770e5e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports